import { NewContacts, AddContacts, Name, Age, Mobile, Save, Cancel } from '../../../../Constant';
import defaultuser from '../../../../assets/images/user/user.png';
import { Btn, Image, H6 } from '../../../../AbstractElements';
import ContactAppContext from '../../../../_helper/Contact';
import React, { Fragment, useContext, useState } from 'react';
import { Users } from 'react-feather';
import {Container, Row, Col, Modal, ModalHeader, ModalBody, Label, Card, CardBody, Input, FormGroup, Form } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from "react-toastify";
import { trackPromise } from 'react-promise-tracker';
import { ProductListDesc, pinagareFilesUpload,pinagareAPIURL } from '../../../../Constant';
import { useNavigate, Link, useParams } from 'react-router-dom';

const CreateContact = (props) => {
  const [addSupervisorModal, setAddSupervisorModal] = useState(false);
  const [addurl, setAddurl] = useState(defaultuser); 
  const [isBoardSupervisorType, setIsBoardSupervisorType] = useState(false);
  const [isPsSupervisorType, setIsPsSupervisorType] = useState(false);
  const history = useNavigate();

  const {
    register,
    handleSubmit,
    reset:reset,
    formState: { errors },
  } = useForm(); // initialise the hook

  const addSupervisorToggle = (event) => {
    event.preventDefault();
     reset();
     //setAnyMeetingApologies(false);
    setAddSupervisorModal(!addSupervisorModal);
  }

  const { createUser } = useContext(ContactAppContext);

  const onSubmit = (data) => {

    if (data !== '') {
  
      let this_eng='';
      let this_body=null;

      //const formData = new FormData();
			            
           // formData.append('eng', "add_pinagare_supervisor");
           // formData.append('omang', localStorage.getItem('username'));
  
        
        this_body=JSON.stringify({
          
        omang:localStorage.getItem('username'),
        eng:'add_pinagare_supervisor', 
        supervisor_data:data,      
        
      });
  
      this_eng='add_pinagare_supervisor';
    
  
      trackPromise(
        pinagareSendRequest(pinagareAPIURL,this_body,this_eng)
       );
  
    } else {
      errors.showMessages();
    }
  };

  const handleSelectChange = (event) => {
  
   // const { name, value } = event.target;
    
      //alert(event.target.name); 
       
    if(event.target.name=="supervisor_type"){
      

      if(event.target.value=="ps_approver"||event.target.value=="psp_approver"){
        setIsPsSupervisorType(true);
        setIsBoardSupervisorType(false);
      }
      else if(event.target.value=="committee_approver"){
        setIsBoardSupervisorType(true);
        setIsPsSupervisorType(false);
      }
      else{
        setIsPsSupervisorType(false);
        setIsBoardSupervisorType(false);
      }

      }else{
        setIsPsSupervisorType(false);
        setIsBoardSupervisorType(false);
      }
      
  }


  async function pinagareSendRequest(url,body,eng) {//alert('d');
    
    try {
      
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((respose) => {
          if (respose.ok) {
        
            return respose.json()
          }
          throw new Error('error')
        })
        .then((data) => {
  
        //alert(eng);
  
          if (data.status!=null&&data.status!=undefined&&data.status) {
  
          
          
                toast.success("Supervisor added Successfully");
                //addSupervisorToggle();
                reset();
                setAddSupervisorModal(!addSupervisorModal);
                history(`${process.env.PUBLIC_URL}/dpsm/home/manage-supervisors`); 
                         
          } else {
            
  
            if(data.status==false){

                toast.error(data.message);
              
            }
            else{             
              
                toast.error(" Network Error occurred... Could not submit request.");
            
            }
           
           
          }
        })
        //.then((error) => {//alert(JSON.stringify(error));
       // })
  
     
    } catch (error) {
      //console.log(JSON.stringify(error)+" --"); 
      toast.error("Network Error occurred.. Could not submit request.."+JSON.stringify(error));
    
    }
  
  }

 



  return (
    <Fragment>
      <Btn attrBtn={{ className: `badge-light-primary align-items-center btn-mail d-flex justify-content-start w-100 emptyContact`, color: 'primery', onClick: addSupervisorToggle }}>
        <Users className='me-2' />
        {"Add Supervisor"}
      </Btn>
      <Modal className='modal-bookmark' isOpen={addSupervisorModal} toggle={addSupervisorToggle} size='lg'>
        <ModalHeader toggle={addSupervisorToggle}>{"Add Supervisor"}</ModalHeader>
        <ModalBody>
          <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit(onSubmit)(e)}}>
            <div className='form-row'>
            <Container fluid={true}>
     
           {/*} <Row>
             <Col sm='12'>
             <Card>
			
      <CardBody>
              <div className='contact-profile'>
                <Image attrImage={{ className: 'rounded-circle img-100', src: `${addurl}`, alt: '' }} />
                
              </div>
              </CardBody>
              </Card>
			
              
              </Col>
            </Row>*/}

              <Row>
                  <Col sm='6'>

              <p >
                <Label><H6>{"Omang Number: "}</H6></Label>
                
                    <input className='form-control input_bodara' name='target_omang' type='text' {...register('target_omang', { required: true })} style={{ border:'1px solid #6ec6ec'}} />
                    <span style={{ color: 'red' }}>{errors.target_omang && 'Omang is required'}</span>
                
              </p>
              <p>	
                <Label><H6>{"Firstname: "}</H6></Label>
                
                    <input className='form-control input_bodara' name='firstname' type='text' {...register('firstname', { required: true })}  style={{ border:'1px solid #6ec6ec'}} />
                    <span style={{ color: 'red' }}>{errors.firstname && 'Firstname is required'}</span>
        </p>   
              
        {isPsSupervisorType && props.pinagareMinistires!=null && props.pinagareMinistires!=undefined? (  <p>
                <Label><H6>{"Ministry: "}</H6></Label>
               
	  <select className='form-control input_bodara' name="supervisor_ministry" {...register('supervisor_ministry', { required: true })}  style={{ border:'1px solid #6ec6ec'}}>
        <option value="">{"Select"}</option>
     { props.pinagareMinistires.map((ministry) => (
            
        <option value={ministry.item_id}>{ministry.full_name}</option>
       
     
    ))}
      </select>
	  
                <span style={{ color: 'red' }}>{errors.supervisor_ministry && 'Please select Ministry for this supervisor.'}</span>
              
			  </p>): isBoardSupervisorType? ( 
 <p>
 <Label><H6>{"Board Position: "}</H6></Label>

<select className='form-control input_bodara' name="board_position" {...register('board_position', { required: true })}  style={{ border:'1px solid #6ec6ec'}}>
<option value="">{"Select"}</option>
<option value="1">Member</option>
<option value="3">Secretary</option>
<option value="2">Chairperson</option>
</select>

 <span style={{ color: 'red' }}>{errors.board_position && 'Please select position for this board member.'}</span>

</p>
        ):null}
			   <p>
                <Label><H6>{"Title: "}</H6></Label>
                
                  <select className='form-control input_bodara' name="title" {...register('title', { required: true })}  style={{ border:'1px solid #6ec6ec'}}>
                  <option value="">{"Select"}</option>
        <option value="Mr">{"Mr"}</option>
        <option value="Mrs">{"Mrs"} </option>
        <option value="Ms">{"Ms"}</option>
        <option value="Dr">{"Dr"} </option>
        <option value="Professor">{"Professor"} </option>
       
        </select>  
                    <span style={{ color: 'red' }}>{errors.title && 'Title is required'}</span>
                 
                </p>
			  <p>
                <Label><H6>{"Gender: "}</H6></Label>
                
        <select className='form-control input_bodara' name="gender" {...register('gender', { required: true })}  style={{ border:'1px solid #6ec6ec'}}>
                  <option value="">{"Select"}</option>
        <option value="Male">{"Male"}</option>
        <option value="Female">{"Female"} </option>
       
        </select>
                    
                    <span style={{ color: 'red' }}>{errors.gender && 'Gender is required'}</span>
            </p>
           	
      </Col>  <Col sm='6'>
     
        <p>
                <Label><H6>{"Supervisor Type: "}</H6></Label>
               
	  <select onClick={(e) => {handleSelectChange(e)}} className='form-control input_bodara'  name="supervisor_type" id="supervisor_type" {...register('supervisor_type', { required: true })}  style={{ border:'1px solid #6ec6ec'}}>
        <option value="">{"Select"}</option>
        <option value="ps_approver">{"Accounting Officer (PS)"}</option>
        <option value="general_approver">{"Secretariat Staff"} </option>
        <option value="committee_approver">{" Board Member"}</option>
		    <option value="psp_approver">{" PSP"}</option>
      </select>
	  
                <span style={{ color: 'red' }}>{errors.supervisor_type && 'Please select type for this Supervisor.'}</span>
              
			  </p>
        <p>
                <Label><H6>{"Lastname: "}</H6></Label>
                
                    <input className='form-control input_bodara' name='lastname' type='text' {...register('lastname', { required: true })}  style={{ border:'1px solid #6ec6ec'}} />
                    <span style={{ color: 'red' }}>{errors.lastname && 'Lastname is required'}</span>
        </p>
        <p>
                <Label><H6>{"Email: "}</H6></Label>
              
                    <input className='form-control input_bodara' name='email_address' type='text' {...register('email_address', { required: true })}  style={{ border:'1px solid #6ec6ec'}} />
                    <span style={{ color: 'red' }}>{errors.email_address && 'Email address is required'}</span>
        </p>
        <p>
                <Label><H6>{"Cellpone Number: "}</H6></Label>
               
                    <input className='form-control input_bodara' name='cellphone' type='text' {...register('cellphone', { required: true })}  style={{ border:'1px solid #6ec6ec'}} />
                    <span style={{ color: 'red' }}>{errors.cellphone && 'Cellphone number is required'}</span>
                 


              </p>	

              </Col>  
                </Row>
                </Container>
			</div>
            <Btn type="Submit" attrBtn={{ color: 'primary', className: 'me-2' }}>{Save}</Btn>
            <Btn attrBtn={{ color: 'secondary', onClick: addSupervisorToggle }}>{Cancel}</Btn>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default CreateContact;
